import React, { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { USERPILOT_APP_ID, USERPILOT_TEST_APP_ID } from "Shared/config/consts"
import { useLoggedInEmployeeProfile } from "Shared/hooks/user.hooks"
import { isDev } from "Shared/utils/helpers"
import { Userpilot } from "userpilot"

const UserPilot: React.FC = () => {
    const location = useLocation()
    const loggedInUser = useLoggedInEmployeeProfile()
    const loggedInUserId = loggedInUser.id
    const [hasBooted, setHasBooted] = useState(false)
    const APP_ID = isDev ? USERPILOT_TEST_APP_ID : USERPILOT_APP_ID

    // when the user ID changes (different logins or logouts), do the corresponding action
    useEffect(() => {
        if (!loggedInUserId && hasBooted) {
            shutdownUserPilot()
        } else if (loggedInUserId && !hasBooted) {
            bootUserPilot()
            identifyUser()
        }
    }, [loggedInUserId])

    useEffect(() => {
        Userpilot.reload()
    }, [location])

    // when user data that is used for userpilot changes, update as well
    useEffect(() => {
        if (loggedInUserId && hasBooted) identifyUser()
    }, [loggedInUser.lastName, loggedInUser.firstName, loggedInUser.activeCompanyProfile?.role, loggedInUser.email, loggedInUser.img, loggedInUser.settings?.language])

    const bootUserPilot = () => {
        Userpilot.initialize(APP_ID ?? "")
        setHasBooted(true)
    }

    const shutdownUserPilot = () => {
        try {
            Userpilot?.destroy()
        } catch (err) {
            console.log("Error shutting down UserPilot", err)
        }
        setHasBooted(false)
    }

    const identifyUser = () => {
        Userpilot.identify(loggedInUser.id, {
            name: loggedInUser.firstName,
            email: loggedInUser.email,
            role: loggedInUser.activeCompanyProfile?.role,
            created_at: (loggedInUser as any).createdAt,
            locale_code: loggedInUser.settings?.language,
        })
    }

    return <></>
}

export default UserPilot
